<template>
  <div class="new-fundraiser-page">
    <div
      class="sub-header success-details"
      data-test="fundraiser-status"
    >
      {{ fundraiserStore.editFundraiser ? 'Fundraiser updated' : 'Fundraiser created' }}
    </div>
    <div class="overflow-y-scroll scrollbar">
      <h5
        class="success-details"
        data-test="fundraiser-message"
      >
        {{
          fundraiserStore.editFundraiser
            ? 'The changes you have made to your fundraiser are now live! Maximize the success of your fundraiser by sharing the custom URL and inviting others to help support your cause!'
            : 'Your fundraiser is now live! Maximize the success of your fundraiser by sharing the custom URL and inviting others to help support your cause! You can manage and edit your fundraisers from the donor portal fundraisers page.'
        }}
      </h5>
      <div class="flex justify-center my-2 md:justify-start">
        <Button
          class="p-button-outlined p-button"
          :style="{ width: '140px', justifyContent: 'center', color: '#000' }"
          @click="openFundraiserPage"
          data-test="visit-page-button"
        >
          <img
            style="padding-right: 5px"
            :src="Eye"
          />Visit Page
        </Button>
      </div>
      <div class="success-details">
        <div class="font-20 weight-500">Share Your Fundraiser</div>
        <div
          class="flex flex-wrap justify-center md:justify-start"
          data-test="fundraiser-success"
        >
          <Button
            class="p-button-outlined p-button p-button-equal-height"
            :style="{ margin: '0 2px 0 0', width: '140px', justifyContent: 'center', fontSize: '14px', color: '#000' }"
            @click="shareToPlatform('facebook')"
            data-test="share-facebook-button"
          >
            <Facebook />Facebook
          </Button>
          <Button
            class="p-button-outlined p-button p-button-equal-height"
            :style="{ margin: '0 2px 0 0', width: '140px', justifyContent: 'center', color: '#000' }"
            @click="shareToPlatform('linkedin')"
            data-test="share-linkedin-button"
          >
            <LinkedIn />LinkedIn
          </Button>
          <Button
            class="p-button-outlined p-button p-button-equal-height"
            :style="{ margin: '0 2px 8px 0', width: '140px', justifyContent: 'center', color: '#000' }"
            @click="shareToPlatform('email')"
            data-test="share-email-button"
          >
            <Email />Email
          </Button>
          <Button
            class="p-button-outlined p-button p-button-equal-height"
            :style="{ margin: '0 2px 8px 0', width: '140px', justifyContent: 'center', color: '#000' }"
            @click="shareToPlatform('twitter')"
            data-test="share-twitter-button"
          >
            <Twitter />Twitter
          </Button>
        </div>
        <div style="text-align: left">Fundraiser URL</div>
        <InputText
          class="w-full max-w-md"
          :value="fullUrl"
          :disabled="true"
          placeholder="Fundraiser URL"
          style="margin-bottom: 8px"
          data-test="fundraiser-url-input"
        />
        <div
          class="copy-url"
          @click="copyDefaultValue"
          data-test="copy-url-button"
        >
          <Copy
            fill="#000000"
            style="margin-right: 4px"
          />Copy To Clipboard
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useDonorStore } from '@/stores/DonorStore.js';
import { useFundraiserStore } from '@/stores/FundraiserStore.js';
import { useSnackbarStore } from '@/stores/SnackbarStore.js';
import Eye from '@/assets/Eye.svg';
import Facebook from '@/assets/Facebook.vue';
import LinkedIn from '@/assets/LinkedIn.vue';
import Twitter from '@/assets/Twitter.vue';
import Email from '@/assets/Email.vue';
import Copy from '@/assets/Copy.vue';

const donorStore = useDonorStore();
const fundraiserStore = useFundraiserStore();
const snackbarStore = useSnackbarStore();
const route = useRoute();

const fundraiserId = parseInt(route.params.idOrName, 10);
const fundraiser = donorStore.getFundraiserById(fundraiserId);
const fullUrl = computed(() => `${donorStore.domain.replace(/\/$/, '')}/fundraiser/${fundraiserStore.urlLink}`);

const copyDefaultValue = () => {
  navigator.clipboard.writeText(fullUrl.value);
  snackbarStore.show('Link Copied!', 'info');
};

const shareToPlatform = (platform) => {
  const text = `Check out this fundraiser: ${fundraiser ? fundraiser.title : fundraiserStore.fundraiserTitle}!`;
  let shareUrl = '';
  switch (platform) {
    case 'facebook':
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${fullUrl.value}&quote=${text}`;
      break;
    case 'linkedin':
      shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${fullUrl.value}&title=${text}`;
      break;
    case 'twitter':
      shareUrl = `https://twitter.com/intent/tweet?url=${fullUrl.value}&text=${text}`;
      break;
    case 'email':
      shareUrl = `mailto:?subject=Check out this fundraiser!&body=${text} ${fullUrl.value}`;
      break;
  }
  window.open(shareUrl, '_blank');
};

const openFundraiserPage = () => {
  window.open(fullUrl.value, '_blank');
};
</script>

<style scoped>
.copy-url {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 8px;
  font-size: 0.875em;
  font-weight: 400;
  color: #000000;
  text-decoration-line: underline;
  margin-bottom: 8px;
  cursor: pointer;
}

.success-details {
  text-align: left;
  width: 430px;
}

.p-button-equal-height {
  display: flex;
  align-items: center;
  height: 48px; /* Ensures consistent button height */
}

@media screen and (max-width: 768px) {
  .success-details {
    text-align: center;
    width: 100%;
  }
}
</style>
